import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { AppSettings } from 'src/app/app.settings';
import { Settings } from 'src/app/app.settings.model';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import moment from 'moment';
import { SchedulerFilterModel } from '../../core/models/scheduler-filter-model';
import { AppointmentModel } from 'src/app/core/models/appointment-model';
import { EventShowStatus, ApiResponseCode, ConfirmeAppointmentTypes } from 'src/app/core/enums';
import { ColorLabel } from 'src/app/core/interfaces/color-label';
import { CancelReason } from 'src/app/core/interfaces/cancel-reason';
import { AppData } from 'src/app/app.data';
import { Utils } from 'src/app/core/utils';


@Injectable({
  providedIn: 'root'
})
export class SchedulerService {

  settings: Settings;
  apiEndPoint: string = Utils.getApiEndPoint(); // environment.APIEndpoint;

  constructor(
    private http: HttpClient,
    private router: Router,
    private appSettings: AppSettings,
    private appData: AppData) {
    this.settings = appSettings.settings;
  }


  loadSchedulersInScope() {
    return this.http.get<any>(this.apiEndPoint + `SchedulerApi/GetSchedulersInScope`)
      .pipe(map(result => {
        // this.loginModel = null;
        return result;
      }));
  }

  loadTherapistsInScope() {
    return this.http.get<any>(this.apiEndPoint + `SchedulerApi/GetTherapistsInScope`)
      .pipe(map(result => {
        // this.loginModel = null;
        return result;
      }));
  }

  loadScheduler() {
    return this.http.get<any>(this.apiEndPoint + `Scheduler`)
      .pipe(map(result => {
        // this.loginModel = null;
        return result;
      }));
  }

  


  loadEvents(filterData: SchedulerFilterModel) {
    return this.http.post<any>(this.apiEndPoint + `AppointmentApi/GetAppointments`, filterData)
      .pipe(map(result => {
        // this.loginModel = null;
        return result;
      }));
  }

  getEvent(eventID: number) {

    return this.http.get<any>(this.apiEndPoint + `AppointmentApi/GetAppointment/${eventID}`)
      .pipe(map(result => {
        // this.loginModel = null;
        return result;
      }));
  }

  getEventRoomInfo(eventID: number) {
    return this.http.get<any>(this.apiEndPoint + `SchedulerApi/GetRoomByEventID/${eventID}`)
      .pipe(map(result => {
        // this.loginModel = null;
        return result;
      }));
  }

  getEventTreatments(eventID: number) {
    return this.http.get<any>(this.apiEndPoint + `TreatmentApi/GetTreatmentByEventID/${eventID}`)
      .pipe(map(result => {
        // this.loginModel = null;
        return result;
      }));
  }

  postEvent(model: AppointmentModel) {

    return this.http.post<any>(this.apiEndPoint + `AppointmentApi/CreateAppointment`, JSON.stringify(model))
      .pipe(map(result => {
        // this.loginModel = null;
        return result;
      }));
  }

  updateEvent(model: AppointmentModel) {
    model.Title = model.EntityName;
    model.PriceListRefID = model.PriceListRefID || 0;
    return this.http.put<any>(this.apiEndPoint + `AppointmentApi/UpdateAppointment/${model.EventID}`, JSON.stringify(model))
      .pipe(map(result => {
        // this.loginModel = null;
        return result;
      }));
  }

  deleteEvent(model: AppointmentModel) {
    return this.http.patch<any>(this.apiEndPoint + `AppointmentApi/DeletePatch/${model.EventID}`, [
      {
        'op': 'replace',
        'path': '/CancelReasonID',
        'value': model.CancelReasonID
      }, {
        'op': 'replace',
        'path': '/CancelReason',
        'value': model.CancelReason
      },{
        'op': 'replace',
        'path': '/AlsoDeleteTreatmentsFromCard',
        'value': model.AlsoDeleteTreatmentsFromCard
      }

      
    ])
      .pipe(map(result => {
        // this.loginModel = null;
        return result;
      }));


    // return this.http.delete<any>(this.apiEndPoint + `Appointment/Delete/${model.EventID}`)
    // .pipe(map(result => {
    //   //this.loginModel = null;
    //   return result;
    // }));
  }

  //   updateClientActivation(client:Client){
  //     return this.http.patch(this.url + "/update/" +
  //              client.clientID, "[{ 'op': 'replace', 'path': 'active', 'value': '" + !client.active + "' }]");
  // }


  getAvailableRooms(branchID: number, date: Date, startTime: string, endTime: string, roomID?: number) {
    const year = date.getFullYear();
    const month = date.getMonth() + 1; // January=0, February=1... => Januaray=1,
    const day = date.getDate();

    // fix date format to YYYY-MM-DD
    const dateString = `${year}-${month}-${day}`;

    let prms = `${branchID}/${dateString}/${startTime}/${endTime}`;
    if(roomID > 0){
      prms += `/${roomID}`;
    }

    return this.http.get<any>(this.apiEndPoint + `SchedulerApi/GetAvailableRooms/${prms}`)
      .pipe(map(result => {
        // this.loginModel = null;
        return result;
      }));
  }

  getColors() {
    
    return this.http.get<any>(this.apiEndPoint + `AppointmentApi/GetColors`)
      .pipe(map(result => {
        // this.loginModel = null;
        if (result.Code === 1) {
          this.appData.ColorLabels = result.Data as ColorLabel[];
        }
        return result;
      }));
  }

  getCancelReasons() {
    
    return this.http.get<any>(this.apiEndPoint + `CancelReasonApi`)
      .pipe(map(result => {

        if (result.Code === ApiResponseCode.Success) {
          this.appData.cancelReasons = result.Data as CancelReason[];
        }
        // this.loginModel = null;
        return result;
      }));
  }

  setPaid(model: AppointmentModel) {
    return this.http.patch<any>(this.apiEndPoint + `AppointmentApi/SetPaid/${model.EventID}`, [
      {
        'op': 'replace',
        'path': '/Paid',
        'value': true
      }
    ])
      .pipe(map(result => {
        // this.loginModel = null;
        return result;
      }));
  }

  confirmAppointment(model: AppointmentModel) {
    
    return this.http.patch<any>(this.apiEndPoint + `AppointmentApi/ConfirmAppointment/${model.EventID}`, [
      {
        'op': 'replace',
        'path': '/Confirmed',
        'value': ConfirmeAppointmentTypes.Confirmed
      }
    ])
      .pipe(map(result => {
        // this.loginModel = null;
        return result;
      }));
  }

  loadCustomerEvents(customerID: number, status: EventShowStatus) {
    return this.http.get<any>(this.apiEndPoint + `AppointmentApi/GetCustomerAppointments/${customerID}/${status}`)
      .pipe(map(result => {
        return result;
      }));
  }

  getSuccessMessageData(eventID: number) {
    return this.http.get<any>(this.apiEndPoint + `AppointmentApi/GetSuccessMessageData/${eventID}`)
      .pipe(map(result => {
        return result;
      }));
  }

  shouldAskForIdNumber(customerID: number){
    return this.http.get<any>(this.apiEndPoint + `AppointmentApi/ShouldAskForIdNumber/${customerID}`)
    .pipe(map(result => {
      return result;
    }));
  }

}
